import { atom } from "jotai";

import { clientFieldApi } from "../services";
import type { ClientOption } from "../types";

export const clientsAtom = atom<ClientOption[]>([]);

export const clientsLoadingAtom = atom(false);

export const loadClientsAtom = atom(null, async (get, set): Promise<void> => {
  if (get(clientsLoadingAtom) || 0 < get(clientsAtom).length) {
    return;
  }

  set(clientsLoadingAtom, true);

  try {
    const clients = await clientFieldApi.fetchClients();

    set(
      clientsAtom,
      clients.filter((client) => client.label),
    );
  } catch {
    // The picker stays on what it had; saving is what reports a server that is
    // not answering.
  } finally {
    set(clientsLoadingAtom, false);
  }
});
